import { IconInfoCircle } from '@tabler/icons-react';

function BrandKitMigrationBanner(): JSX.Element {
  return (
    <div className="mt-4 pl-7 pr-4">
      <div className="flex gap-3 rounded-xl border border-orange-100 bg-orange-50 p-4">
        <IconInfoCircle size={20} stroke={1.75} className="mt-0.5 shrink-0" />
        <div className="min-w-0 space-y-1 text-sm">
          <p className="font-semibold">Brand Kit Migration</p>
          <p>
            We&apos;re consolidating brand kits into one place. Content Lab and the video editor will soon pull from
            your global Brand Kit – no changes needed on your end.
          </p>
        </div>
      </div>
    </div>
  );
}

export default BrandKitMigrationBanner;
